<i18n>
[
    "global__previous",
    "global__next",
]
</i18n>
<template>
    <div>
        <PaginationButton
            :label="$t('global__previous')"
            :isDisabled="pagination.pageNumber === 1"
            :isLight="true"
            direction="backward"
            class="c-pagination__page-icon c-pagination__page-icon--prev"
            @click="onClickPagination(PREVIOUS)"
        />
        <span class="u-text--gray">
            {{ `${pagination.pageNumber} / ${pagination.totalPages}` }}
        </span>
        <PaginationButton
            :label="$t('global__next')"
            :isDisabled="pagination.pageNumber === pagination.totalPages"
            :isLight="true"
            direction="forward"
            class="c-pagination__page-icon c-pagination__page-icon--next"
            @click="onClickPagination(NEXT)"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import { PAGINATION_CLICK } from '~coreModules/core/js/global-event-constants';
import { PREVIOUS, NEXT } from '~coreModules/core/js/constants';
import { GLOBAL_EVENT } from '~coreModules/core/js/store';
import PaginationButton from '~coreModules/core/components/ui/buttons/PaginationButton.vue';

export default {
    name: 'CorePagination',
    components: {
        PaginationButton,
    },
    props: {
        pagination: {
            type: Object,
            required: true,
        },
        additionalAnalyticsData: {
            type: Object,
            default: () => ({ }),
        },
    },
    emits: ['click'],
    data() {
        return {
            PREVIOUS,
            NEXT,
        };
    },
    methods: {
        ...mapActions({
            trackGlobalEvent: GLOBAL_EVENT,
        }),
        onClickPagination(direction) {
            const newPage = direction === NEXT ? this.pagination.pageNumber + 1 : this.pagination.pageNumber - 1;
            this.$emit('click', newPage);

            this.trackGlobalEvent({
                type: PAGINATION_CLICK,
                data: {
                    action: 'product-grid-paginate',
                    label: direction,
                    value: newPage,
                    ...this.additionalAnalyticsData,
                },
            });
        },
    },
};
</script>

<style lang="scss">
    .c-pagination {
        &__page-icon {
            &--prev {
                margin-right: $nu-spacer-2;
            }

            &--next {
                margin-left: $nu-spacer-2;
            }
        }
    }
</style>
